import client from "../client";

const getSettings = () => client.get<any>("/app-settings");

const updateSettings = (data: any) => client.patch<any>("/app-settings", data);

const broadcastPush = (data: { title: string; message: string }) =>
  client.post<any>("/notifications/broadcast", data);

const appSettingApi = {
  getSettings,
  updateSettings,
  broadcastPush,
};

export default appSettingApi;
